// Code generated by Slice Machine. DO NOT EDIT.

import dynamic from "next/dynamic";

export const components = {
  content_box: dynamic(() => import("./ContentBox")),
  game_parallax_section: dynamic(() => import("./GameParallaxSection")),
  games_carousel: dynamic(() => import("./GamesCarousel")),
  games_grid: dynamic(() => import("./GamesGrid")),
  information_section: dynamic(() => import("./InformationSection")),
  media_carousel: dynamic(() => import("./MediaCarousel")),
  parallax_section: dynamic(() => import("./ParallaxSection")),
  promotion: dynamic(() => import("./Promotion")),
  quest_carousel: dynamic(() => import("./QuestCarousel")),
  section_divider: dynamic(() => import("./SectionDivider")),
  any_video_embed: dynamic(() => import("./AnyVideoEmbed")),
};
